import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'UpgradeLicenseButton' })({
    root: {
        padding: '16px 24px',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 12,
        whiteSpace: 'nowrap',
        background: '#232323 !important',
        color: '#fff',
        ['@media (max-width: 480px)']: {
            display: 'none'
        }
    }
});
